export default "__VITE_ASSET__CcQibFQQ__"